import DatetimeUtils from "../../gd/utils/datetime-utils"
import RecentTaskModel from "./recent-task"
import {SortDirection} from "../../data-structures/sort"
import StackFILO from "../../data-structures/stack-filo";

const debug = false
// const debug = "RecentTasks"

export default class RecentTasks extends StackFILO<RecentTaskModel> {

    protected stackSize: number = 100

    async init() {
        if (!gd.companyId) return

        debug && console.groupCollapsed(debug, "init")

        const initModels : RecentTaskModel[] = []

        // init tasks from DB if not localstorage found
        const lsTasks = localStorage.getItem('recent.tasks.{0}'.f(gd.companyId))

        if (lsTasks !== null) {
            debug && console.log(debug, "Local storage found. Process...")
            const arr = lsTasks.split(",")

            _.map(arr, (value) => {
                const parts = value.split("-")

                const recentTask = new RecentTaskModel({
                    taskId  : parts[0],
                    date    : moment.utc(parts[1], 'X').local()
                })

                if (recentTask.date.isValid()) {
                    initModels.push(recentTask)
                }


            })
            this.reset(initModels)

            if (debug) {
                console.log(debug, "Init from Local Storage Done")
                this.debug();
            }
        } else {
            if (!gd.session.me.id || !gd.companyId) return

            debug && console.log(debug, "[RECENT] tasks not found - need to init from DB");

            const response = await gd.api.Recent.tasks().promise()

            _.map(response, (i)=>{
                initModels.push(new RecentTaskModel({
                    taskId  : i.taskId,
                    date    : DatetimeUtils.datetimeToMoment(i.date)
                }))
            })

            this.reset(initModels)

            if (debug) {
                console.log(debug, "[RECENT TASKS] Init tasks from db done: ");
                this.debug()
            }

            this.save()
        }

        debug && console.groupEnd()
    }

    isTaskOpenedToday(taskId:ID) {
        const today = moment()
        const tasks = _.filter(this.models, (r:RecentTaskModel) => r.taskId === taskId && r.date.isSame(today,'day'))

        const isOpen = (tasks.length > 0)

        if (debug) console.log("[RECENT TASKS].isTaskOpenToday",taskId,"isOpen=",isOpen)

        return isOpen
    }

    toString() {
        return _.map(this.models,(r:RecentTaskModel) => r.localStorageFormat()).join(',')
    }

    save() {
        debug && console.log(debug, "[Recent Tasks].save()",this.toString())
        localStorage.setItem('recent.tasks.'+gd.companyId, this.toString())

        gd.bus.triggerEvent('recent-tasks:update')
    }

    getSorted() {
        this.models = _.orderBy(this.models, (r:RecentTaskModel)=>r.date.format("X"), SortDirection.DESC)
        return this;
    }

    exportTasks() {
        return _.map(this.models, (r:RecentTaskModel)=>r.getTask())
    }

    taskView(task: any) {
        const recentTask = this.get(task.id)
        const now = moment()

        if (recentTask) {
            recentTask.date = now
        } else {
            this.add(new RecentTaskModel({
                taskId              : task.id,
                date                : now,
                title               : task.title,
                taskTypeId          : task.taskTypeId ? task.taskTypeId : task.type,
                projectId           : task.projectId,
                companyId           : gd.companyId,
                actionRequiredUserId: task.arUserId ? task.arUserId : task.actionRequiredUserId
            }))
        }

        this.save()
    }

    tasksRemove(removedTasksIds: ID[]) {
        removedTasksIds.map(tid=>{this.remove(tid)})
        this.save()
    }

    debug() {
        _.map(this.models, (r:RecentTaskModel)=>{console.log(r.taskId,r.date.format("MMM-DD H:mm:ss"),r.date)})
    }
}